import { notification } from 'antd';
import { CheckCircleOutlined, CloseCircleOutlined, InfoCircleOutlined, ExclamationCircleOutlined } from '@ant-design/icons';
import { statusTokens } from '../theme/theme';

// Funzione helper per creare notifiche con configurazione standard
const createNotification = (type, message, description, placement = 'topRight') => {
    const iconMap = {
        success: <CheckCircleOutlined style={{ color: statusTokens.success }} />,
        error: <CloseCircleOutlined style={{ color: statusTokens.error }} />,
        warning: <ExclamationCircleOutlined style={{ color: statusTokens.warning }} />,
        info: <InfoCircleOutlined style={{ color: statusTokens.info }} />,
    };

    notification[type]({
        message,
        description,
        placement,
        icon: iconMap[type],
    });
};

// Funzioni di notifica esportate
export const showSuccessNotification = (message = 'Success', description = 'Operation completed successfully!') => {
    createNotification('success', message, description);
};

export const showErrorNotification = (message = 'Error', description = 'An error occurred during the operation!') => {
    createNotification('error', message, description);
};

export const showWarningNotification = (message = 'Warning', description = 'Warning: This action may have consequences!') => {
    createNotification('warning', message, description);
};

export const showInfoNotification = (message = 'Information', description = 'This is an informational message.') => {
    createNotification('info', message, description);
};

// Funzione unificata che può essere utilizzata per tutti i tipi di notifiche
export const showNotification = (type, message, description) => {
    if (!['success', 'error', 'warning', 'info'].includes(type)) {
        console.error(`Invalid notification type: ${type}`);
        return;
    }

    createNotification(type, message, description);
};

// Configurazione globale delle notifiche (opzionale)
export const configureNotifications = (config) => {
    notification.config(config);
}; 